import { SnowplowTempStorage } from './analytics'

type StorageKey = keyof WindowLocalStorage | keyof WindowSessionStorage
type StorageItemKey = keyof typeof LocalStorage | keyof typeof SessionStorage

const _set = <DefaultValueType>(
  storage: StorageKey,
  key: StorageItemKey,
  value: DefaultValueType
) => {
  window[storage].setItem(key, JSON.stringify(value))
}

const _get = <DefaultValueType>(
  storage: StorageKey,
  key: StorageItemKey,
  defaultValue?: DefaultValueType
): DefaultValueType | undefined => {
  const item = window[storage].getItem(key)

  if (!item && typeof defaultValue !== 'undefined') {
    _set(storage, key, defaultValue)
    return defaultValue
  }

  return JSON.parse(item)
}

const createItem = <DefaultValueType>(storage: StorageKey, key: any) => ({
  get: (defaultValue?: DefaultValueType) => _get(storage, key, defaultValue),
  set: (value: DefaultValueType) => _set(storage, key, value),
  remove: () => window[storage].removeItem(key),
})

const createLocalItem = <DefaultValueType = any>(key: string) =>
  createItem<DefaultValueType>('localStorage', key)
const createSessionItem = <DefaultValueType = any>(key: string) =>
  createItem<DefaultValueType>('sessionStorage', key)

export const LocalStorage = {
  timelineFilters: createLocalItem('timelineFilters'),
  chatSettings: createLocalItem('chatSettings'),
  settings: createLocalItem<{
    groups?: { hideRepliesOnTimeline?: boolean }
    activities?: { singleFeed?: boolean }
  }>('settings'),
  hideDownloadAppAlert: createLocalItem('hideDownloadAppAlert'),
  willLeaveConferenceId: createLocalItem('willLeaveConferenceId'),
  callDuration: createLocalItem('callDuration'),
  callTotalUsers: createLocalItem('callTotalUsers'),
  callInUse: createLocalItem('callInUse'),
  callInUseAlertCount: createLocalItem('callInUseAlertCount'),
  callWaitingVolume: createLocalItem('callWaitingVolume'),
  callSettings: createLocalItem('callSettings'),
}

export const SessionStorage = {
  birthdayLetter: createSessionItem('birthdayLetter'),
  himanowTimestamp: createSessionItem<number>('himanowTimestamp'),
  snowplowTemp: createSessionItem<SnowplowTempStorage>('snowplowTemp'),
  authorizeWalletParams: createSessionItem<string>('authorizeWalletParams'),
}
